import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Capture from "./Pages/PhotoBooth/Capture";
// import Gallery from "./Pages/PhotoBooth/Gallery/gallery";
import "./Assets/css/bootstrap.min.css";
import "./Assets/css/animation.css";
import "./Assets/css/reset.css";
import "./Assets/css/style.css";
import "./Assets/css/form.css";
import "./Assets/css/effectanimation.css";
import "./Assets/css/responsive.css";
import "./Assets/css/custom.css";
import NotFound from "./Pages/404";
// import Login from "./Pages/Login";
import { ErrorContext, UserContext } from "./context";
import Login from "./Pages/Login";

export default function App() {
  const [user, setUser] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) setTimeout(() => setError(null), 3000);
  }, [error]); // eslint-disable-line

  return (
    <BrowserRouter basename="/diwali_photobooth">
      <UserContext.Provider value={{ user, setUser }}>
        <ErrorContext.Provider value={{ error, setError }}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/capture"
              element={user.name ? <Capture /> : <Navigate to="/" />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorContext.Provider>
      </UserContext.Provider>
    </BrowserRouter>
  );
}
